"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLicensePlate = void 0;
function isLicensePlate(value, options) {
    var required = options && options.required !== undefined ? options.required : true;
    var hasLength = options && options.hasLength !== undefined ? options.hasLength : undefined;
    var isValid = true;
    var errors;
    var licensePlateRegex = /^[A-Z0-9]*$/;
    if (hasLength && value && value.replace(" ", "").length !== hasLength) {
        return {
            isValid: false,
            errors: {
                value: value,
                constraints: {
                    hasLength: "false",
                },
            },
        };
    }
    if ((required && !value) || (value && !value.match(licensePlateRegex))) {
        return {
            isValid: false,
            errors: {
                value: value,
                constraints: {
                    isValidLicensePlate: "false",
                },
            },
        };
    }
    if (value && value.length > 10) {
        return {
            isValid: false,
            errors: {
                value: value,
                constraints: {
                    licensePlateTooLong: "true",
                },
            },
        };
    }
    return {
        isValid: isValid,
        errors: errors,
    };
}
exports.isLicensePlate = isLicensePlate;
